/**
 * The mode the request-details page renders in, resolved from the route:
 *  - Read    → `/time-off/:requestId` or `/team/:memberId/time-off/:requestId`
 *  - Create  → `/time-off/new`
 *  - Approve → `/time-off/approvals/:requestId`
 *  - Edit    → editable state entered from read mode when backend allows it
 */
export enum TimeOffDetailsMode {
  Read = 'read',
  Create = 'create',
  Approve = 'approve',
  Edit = 'edit',
}
